import { useState } from 'react';
import './Noticias.css';
import { noticiasData } from '../../constants/noticias';

function Noticias() {
  const [modalAberto, setModalAberto] = useState(null);

  const abrirModal = (noticiaId) => {
    setModalAberto(noticiaId);
    document.body.style.overflow = 'hidden';
  };

  const fecharModal = () => {
    setModalAberto(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <section id="noticias" className="noticias-section">
      <div className="noticias-container">
        <h2 className="noticias-titulo">Notícias</h2>

        <div className="noticias-grid">
          {noticiasData.map((noticia) => (
            <div
              key={noticia.id}
              className="noticia-card"
              onClick={() => abrirModal(noticia.id)}
            >
              <span className="noticia-data">{noticia.data}</span>
              <h3 className="noticia-card-titulo">{noticia.titulo}</h3>
              <p className="noticia-resumo">{noticia.resumo}</p>
              <span className="noticia-leia-mais">Leia mais →</span>
            </div>
          ))}
        </div>
      </div>

      {modalAberto && (
        <div className="noticia-modal-overlay" onClick={fecharModal}>
          <div className="noticia-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="noticia-modal-fechar" onClick={fecharModal}>
              ✕
            </button>

            {noticiasData
              .filter((noticia) => noticia.id === modalAberto)
              .map((noticia) => (
                <div key={noticia.id} className="noticia-modal-body">
                  <span className="noticia-modal-data">{noticia.data}</span>
                  <h2 className="noticia-modal-titulo">{noticia.titulo}</h2>

                  <div className="noticia-modal-texto">
                    {noticia.conteudo.map((paragrafo, index) => (
                      <p key={index}>{paragrafo}</p>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default Noticias;
